/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateGcpIamCredentialRequestBody,
  UpdateGcpIamCredentialRequestBody$Outbound,
  UpdateGcpIamCredentialRequestBody$outboundSchema,
} from "../components/updategcpiamcredentialrequestbody.js";

export type UpdateGcpIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateGcpIamCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateGcpIamCredentialRequestBody: UpdateGcpIamCredentialRequestBody;
};

/** @internal */
export type UpdateGcpIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateGcpIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  UpdateGcpIamCredentialSecurity$Outbound,
  UpdateGcpIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateGcpIamCredentialSecurityToJSON(
  updateGcpIamCredentialSecurity: UpdateGcpIamCredentialSecurity,
): string {
  return JSON.stringify(
    UpdateGcpIamCredentialSecurity$outboundSchema.parse(
      updateGcpIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type UpdateGcpIamCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateGcpIamCredentialRequestBody: UpdateGcpIamCredentialRequestBody$Outbound;
};

/** @internal */
export const UpdateGcpIamCredentialRequest$outboundSchema: z.ZodMiniType<
  UpdateGcpIamCredentialRequest$Outbound,
  UpdateGcpIamCredentialRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateGcpIamCredentialRequestBody:
      UpdateGcpIamCredentialRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateGcpIamCredentialRequestBody: "UpdateGcpIamCredentialRequestBody",
    });
  }),
);

export function updateGcpIamCredentialRequestToJSON(
  updateGcpIamCredentialRequest: UpdateGcpIamCredentialRequest,
): string {
  return JSON.stringify(
    UpdateGcpIamCredentialRequest$outboundSchema.parse(
      updateGcpIamCredentialRequest,
    ),
  );
}
